import React, { useRef } from "react";
import { Loading } from "../../common/components/loading";
import OpenModalButton from "../../common/components/openModalButton";
import DatesHelper from "../../common/datesHelper";
import ContrattoWidget from "./ContrattoWidget";
import { AccordionItem } from "../../common/accordion";
import ContrattiActions from "../ContrattiActions";
import ContrattoForm from "./ContrattoForm";
import { Divider } from "../../common/components/CmForms";
import ContrattiStore from "../ContrattiStore";

export const ContrattiAccordion = (props: { idImpianto: number }) => {
    const contratti = ContrattiStore.useContratti(props.idImpianto);
    const modal = useRef<OpenModalButton>(null);
    if (!contratti)
        return <Loading />;

    const today = DatesHelper.Today();
    const contrattoValid = contratti.find(x => x.inizioValidita <= today && x.fineValidita >= today);
    return <AccordionItem className="my-4"
        open={contratti.length > 0}
        heading={isOpen =>
            <div>
                <Divider
                    caption={
                        <span>
                            <span className="badge rounded-pills bg-info me-2">{contratti.length}</span>
                            Contratti
                            {contratti.length > 0 && <i className={`${isOpen ? "fas fa-chevron-up" : "fas fa-chevron-down"} ms-3`} />}
                        </span>
                    }
                    color={contrattoValid ? "theme" : "warning"}
                    additionalItems={
                        <>
                            <div className="me-3">{contrattoValid ? <div className="text-info"><i className="fas fa-check me-2" />Contratto valido (scadenza: {DatesHelper.getReadableDateString(contrattoValid.fineValidita)})</div> : contratti.length > 0 ? <div className="text-warning"><i className="fas fa-times" />  Contratto scaduto</div> : undefined}</div>
                            <OpenModalButton
                                ref={modal}
                                title="Aggiungi contratto di assistenza"
                                className="btn btn-outline-secondary me-1"
                                modalContent={<div>
                                    <h3>Aggiungi contratto di manutenzione</h3>
                                    <ContrattoForm
                                        onSubmit={c => {
                                            c.id ? ContrattiActions.update(c) : ContrattiActions.add(c);
                                            modal.current?.close();
                                        }}
                                        contratto={{ idImpianto: props.idImpianto }}
                                        onCancel={() => modal.current?.close()}
                                    />
                                </div>}
                            >
                                <i className="fas fa-plus" /> Contratto
                            </OpenModalButton>
                        </>
                    }
                />
            </div>
        }>
        <div className="d-flex flex-wrap">
            {contratti.map(x =>

                <ContrattoWidget key={x.tipoContrattoId} contratto={x} />
            )}
        </div>
    </AccordionItem>
    { }

}